class Country {
  public readonly name: string;
  public readonly value: string;

  constructor({ name, value }: { name: string; value: string }) {
    this.name = name;
    this.value = value;
  }

  public static fromJSON = (v: any) => {
    const { name, value } = Object.assign({}, v);

    if (typeof name !== 'string') throw new TypeError('.name must be a string');
    if (typeof value !== 'string') throw new TypeError('.value must be a string');

    return new Country({
      name,
      value,
    });
  };
}

export default Country;
